import { ArrowRight, Heart, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router';

import { CONTACT, SITE } from '@/config/site';
import { WA_LINKS } from '@/lib/whatsapp';

import { Container } from '../common/Container';
import { PawIcon, WhatsAppIcon } from '../common/icons';
import { Button } from '../ui/button';

export function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-brown-950 py-16 lg:py-24">
      {/* Ambient blobs */}
      <div
        className="pointer-events-none absolute top-0 right-0 size-72 translate-x-1/3 -translate-y-1/3 rounded-full bg-caramel-500/10"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute bottom-0 left-0 size-56 -translate-x-1/3 translate-y-1/3 rounded-full bg-orange-500/10"
        aria-hidden="true"
      />
      <PawIcon
        className="pointer-events-none absolute top-10 left-[10%] size-14 animate-float-paw text-caramel-500/10"
        aria-hidden="true"
      />
      <PawIcon
        className="pointer-events-none absolute right-[12%] bottom-12 size-10 animate-float-paw text-caramel-500/10"
        style={{ animationDelay: '2s' }}
        aria-hidden="true"
      />

      <Container size="sm" className="relative z-10 flex flex-col items-center gap-6 text-center">
        <Heart className="size-11 text-orange-500" fill="currentColor" aria-hidden="true" />

        <h2 className="text-3xl leading-tight font-extrabold text-balance text-cream-100 lg:text-5xl">
          Seu pet merece cuidado, qualidade e uma boa alimentação
        </h2>

        <p className="max-w-xl text-base leading-relaxed text-cream-300 lg:text-lg">
          Monte seu pedido em minutos e finalize com nossa equipe no WhatsApp. Simples, rápido e sem
          burocracia.
        </p>

        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <Button asChild size="lg" className="sm:min-w-56">
            <Link to="/catalogo">
              Montar meu pedido
              <ArrowRight aria-hidden="true" />
            </Link>
          </Button>

          <Button asChild variant="whatsapp" size="lg">
            <a href={WA_LINKS.general} target="_blank" rel="noopener noreferrer">
              <WhatsAppIcon aria-hidden="true" />
              Chamar no WhatsApp
            </a>
          </Button>
        </div>

        <div className="mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm font-semibold text-caramel-500">
          <a
            href={`tel:+${CONTACT.whatsappNumber}`}
            className="-my-1 flex items-center gap-1.5 py-1 transition-colors hover:text-cream-100"
          >
            <Phone className="size-4" aria-hidden="true" />
            {CONTACT.whatsappDisplay}
          </a>

          <span className="text-brown-700" aria-hidden="true">
            |
          </span>

          <span className="flex items-center gap-1.5">
            <MapPin className="size-4" aria-hidden="true" />
            {SITE.serviceArea}
          </span>
        </div>
      </Container>
    </section>
  );
}
